import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PuntosInteresService } from './../../../../services/puntos-interes.service';
import { MapaService } from './../../../../services/mapa.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';

@Component({
	selector: 'kt-guardar-punto-interes',
	templateUrl: './guardar-punto-interes.component.html',
	styleUrls: ['./guardar-punto-interes.component.scss']
})
export class GuardarPuntoInteresComponent implements OnInit {
	public formPInteres: FormGroup;
	public coordenadas;
	public titulo: string = 'Agregar Punto de Interés';
	public esEditable: boolean = false;
	public idPunto: number;

	marcadores: any[] = [
		{ url: './assets/media/puntosInteres/punto_de_interes.png', nombre: 'Punto de Interés' },
		{ url: './assets/media/puntosInteres/fabricas_y_talleres.png', nombre: 'Fabricas y Talleres' },
		{ url: './assets/media/puntosInteres/supermercado.png', nombre: 'Supermercado' },
		{ url: './assets/media/puntosInteres/negocios_miscelaneos.png', nombre: 'Negocios y Miscelaneos' },
		{ url: './assets/media/puntosInteres/restaurantes.png', nombre: 'Restaurantes' },
		{ url: './assets/media/puntosInteres/bancos.png', nombre: 'Bancos' },
		{ url: './assets/media/puntosInteres/gimnacios_y_clubes_deportivos.png', nombre: 'Gimnacios y Clubes Deportivos' },
		{ url: './assets/media/puntosInteres/laboratorios_y_clinicas.png', nombre: 'Laboratorios y clínicas' },
		{ url: './assets/media/puntosInteres/libriotecas_librerias_y_escuelas.png', nombre: 'Bibliotecas, Librerias y Escuelas' },
		{ url: './assets/media/puntosInteres/teatros_cines_y_cabaret.png', nombre: 'Teatros, Cines y Cabaret' },
		{ url: './assets/media/puntosInteres/vigilancia.png', nombre: 'Vigilancia' },
		{ url: './assets/media/puntosInteres/casetas_de_peaje.png', nombre: 'Casetas de Peaje' },
		{ url: './assets/media/puntosInteres/gasolinerias_y_casetas_de_servicio.png', nombre: 'Gasolineras y Casetas de Servicio' },
		{ url: './assets/media/puntosInteres/constructores_y_minas.png', nombre: 'Constructores y Minas' },
		{ url: './assets/media/puntosInteres/oficinas_de_gobierno.png', nombre: 'Oficinas de Gobierno' },
		{ url: './assets/media/puntosInteres/comunicacion_y_control.png', nombre: 'Comunicación y control' },
		{ url: './assets/media/puntosInteres/sitios_turisticos_y_monumentos.png', nombre: 'Sitios Turisticos y Monumentos' },
		{ url: './assets/media/puntosInteres/edificios_publicos_y_hoteles.png', nombre: 'Edificios Públicos y Hoteles' },
		{ url: './assets/media/puntosInteres/parques_viveros_y_bosques.png', nombre: 'Parques, Viveros y Bosques' },
		{ url: './assets/media/puntosInteres/estaciones_y_cruces_de_ferrocarril.png', nombre: 'Estaciones y Cruces de Ferrocarril' },
		{ url: './assets/media/puntosInteres/muelles.png', nombre: 'Muelles' },
		{ url: './assets/media/puntosInteres/aeropuertos.png', nombre: 'Aeropuertos' },
		{ url: './assets/media/puntosInteres/puntos_de_inspeccion_y_retenciones.png', nombre: 'Puntos de Insepección y Retenciones' },
		{ url: './assets/media/puntosInteres/policia_y_aduanas.png', nombre: 'Policia y Aduanas' },
		{ url: './assets/media/puntosInteres/bases_militares.png', nombre: 'Bases Militares' },
		{ url: './assets/media/puntosInteres/bodegas.png', nombre: 'Bodegas' },
		{ url: './assets/media/puntosInteres/administracion_y_monitoreo.png', nombre: 'Administración y Monitoreo' },
		{ url: './assets/media/puntosInteres/templos_y_sinagogas.png', nombre: 'Templos y Sinagogas' },
		{ url: './assets/media/puntosInteres/hospitales_y_servicios_medicos.png', nombre: 'Hospitales y Servicios Medicos' },
		{ url: './assets/media/puntosInteres/bases_fronteras_y_poblados.png', nombre: 'Bases, Fronteras y Poblados' },
		{ url: './assets/media/puntosInteres/ganaderia_y_ranchos.png', nombre: 'Ganadería y Ranchos' },
		{ url: './assets/media/puntosInteres/iglesias_y_cementerios.png', nombre: 'Iglesias y Cementerios' },
		{ url: './assets/media/puntosInteres/edificaciones_diversas.png', nombre: 'Edificaciones Diversas' },
		{ url: './assets/media/puntosInteres/puntos_de_control.png', nombre: 'Puntos de Control' },
		{ url: './assets/media/puntosInteres/edificios_condominios_y_departamentos.png', nombre: 'Edificios, Condominios y Departamentos' },
		{ url: './assets/media/puntosInteres/bares_y_cantinas.png', nombre: 'Bares y Cantinas' },
		{ url: './assets/media/puntosInteres/playas_y_balnearios.png', nombre: 'Playas y Balnearios' },
		{ url: './assets/media/puntosInteres/telefonia_y_telegrafos.png', nombre: 'Telefonía y Telegrafos' },
		{ url: './assets/media/puntosInteres/estadios_palenques_y_plazas.png', nombre: 'Estadios, Palenques y Plazas' },
		{ url: './assets/media/puntosInteres/talleres_y_refaccionarias.png', nombre: 'Talleres y Refaccionarias' },
		{ url: './assets/media/puntosInteres/estetica_peluquerias_y_spas.png', nombre: 'Estetica, Peluquerias y Spas' },
		{ url: './assets/media/puntosInteres/nc.png', nombre: 'NC'},
		{ url: './assets/media/puntosInteres/gtac.png', nombre: 'GTAC'},
		{ url: './assets/media/puntosInteres/sacmex.png', nombre: 'SACMEX'},
	];

	constructor(private mapaService: MapaService,
		private puntosInteresService: PuntosInteresService,
		private toastService: ToastrService,
		private formBuilder: FormBuilder,
		public dialogRef: MatDialogRef<GuardarPuntoInteresComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any) { }

	ngOnInit() {
		this.initForm();
		if (this.data !== null) {
			this.titulo = 'Editar Punto de Interés';
			this.esEditable = true;
			this.idPunto = this.data.id;
			this.obtenerDatos(this.data);
		}
	}

	initForm() {
		this.formPInteres = this.formBuilder.group({
			nombre: ['', Validators.compose([
				Validators.required
			])],
			descripcion: ['', Validators.compose([
				Validators.required
			])],
			icono: ['', Validators.compose([Validators.required])],
			coordenadas: [this.mapaService.coordenadaPI]
		});
	}

	obtenerDatos(datosPunto) {
		this.formPInteres.patchValue(datosPunto);
	}

	onSubmit() {
		let datos = this.formPInteres.value;

		if (this.esEditable) {
			this.actualizarPuntosInteres(datos);
		} else {
			this.guardarPuntoInteres(datos);
		}

	}

	guardarPuntoInteres(datos) {
		this.puntosInteresService.postPinteres(datos).pipe(
			finalize(
				() => {
					this.pintarMarcadoresPuntosInteres();
				}
			)
		).subscribe(success => {
			//location.reload();
			this.toastService.success('Se guardaron los datos', 'Éxito');
			this.resetForm();
			this.dialogRef.close();
		}, error => {
			this.toastService.error('' + error, 'Error');
			this.dialogRef.close();
		});
	}

	actualizarPuntosInteres(datos) {
		this.puntosInteresService.updatedPunto(this.idPunto, datos).pipe(
			finalize(
				() => {
					this.pintarMarcadoresPuntosInteres();
				}
			)
		).subscribe(success => {
			//location.reload();
			this.toastService.success('Se actualizaron los datos', 'Éxito');
			this.resetForm();
			this.dialogRef.close();
		}, error => {
			this.toastService.error('' + error, 'Error');
			this.dialogRef.close();
		});
	}

	public pintarMarcadoresPuntosInteres() {
		this.puntosInteresService.getPuntos().subscribe(
			(res: any[]) => {
				this.mapaService.pintarPuntosInteres(res);
			}, err => {
			});
	}

	resetForm() {
		this.formPInteres = this.formBuilder.group({
			nombre: [''],
			descripcion: [''],
			icono: [''],
			coordenadas: [[]]
		});
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


}
